import axiosInstance from '../Api/axiosInstance';

export const getAnalytics = () => axiosInstance.get('/analytics');
